import { render, staticRenderFns } from "./ServiceTypesView.vue?vue&type=template&id=b23eae1e"
import script from "./ServiceTypesView.vue?vue&type=script&lang=js"
export * from "./ServiceTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports